import imageLinks from "../../images/links_small.png";
import { ReactComponent as ImageLinked } from '../../images/flightplan/link.svg';
import { ReactComponent as ImageHeli } from '../../images/copilot/heli.svg';
import { ReactComponent as ImageCessna } from '../../images/copilot/cessna.svg';
import { ReactComponent as ImageNavi } from '../../images/copilot/navi.svg';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import PencilIcon from '@material-ui/icons/Create';

import { Box, Button, Dialog, DialogContent, IconButton, makeStyles, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Switch, InputAdornment, Select, MenuItem, DialogContentText, DialogActions } from "@material-ui/core";
import clsx from "clsx";
import { forwardRef, useRef, useState, useImperativeHandle, createRef, Suspense, useEffect, useMemo } from "react";
import { useRecoilRefresher_UNSTABLE, useRecoilValue } from "recoil";
import { useTranslation } from "react-i18next";
import { Controller, useForm } from "react-hook-form";
import { freeCoPilotListState, linkableFlightPlanState, useCoPilotLinkageList } from "../../store/CoPilotSettingState";
import { Loading } from "../../parts/Loading";
import { useAlert } from "../../hooks/useAlert";
import { useCallback } from "react";
import { memo } from "react";
import { userState } from "../../store/UserState";
import RoleControl from "../RoleControl";
import { SUBJ_COPI_AIRCRAFT_LINKAGE, VERB_UPDATE } from "../../utils/AccessControl";
import { useLinkableSourceList } from "../../store/AircraftSettingState";

const useStyles = makeStyles({
	container: {
		height: '100%',
	},
	stickyTable: {
		borderCollapse: 'separate',
		marginBottom: '1px',
	},
	notAssociatedBox: {
		height: '15%',
		marginTop: 5,
		textAlign: 'left',
	},
	divider: {
		margin: '4px 0',
		border: 'none',
		borderTop: 'solid 1px rgb(167,167,167)',
	},
	notAssociateTitle: {
		fontWeight: 500,
		height: 16,
		padding: '2px 0',
	},
	notAssociateList: {
		height: 'calc(100% - 20px)',
		overflow: 'auto',
	},
	notAssociateItem: {
		display: 'inline-flex',
		'&:not(:last-child)': {
			'&:after': {
				content: "','",
				margin: '0 5px 0 1px',
			},
		}
	},
	tableCell: {
		backgroundColor: 'white',
		borderRight: '1px solid #a7a7a7',
		borderBottom: '1px solid #a7a7a7',
		'th&': {
			borderTop: '1px solid #a7a7a7',
		},
		'&:nth-child(1)': {
			position: 'sticky',
			left: 0,
			zIndex: 2,
			borderLeft: '1px solid #a7a7a7',
		},
		'&:nth-child(2)': {
			position: 'sticky',
			left: '34px',
			zIndex: 2,
		},
	},
	headerCell: {
		position: 'sticky',
		zIndex: 3,
		top: 0,
		color: '#fff',
		backgroundColor: '#4c4f53',
		whiteSpace: 'nowrap',
		'&:nth-child(-n+2)': {
			zIndex: 4
		},
		'& a:link, a:visited': {
			color: '#fff',
		},
	},
	headerSubCell: {
		color: '#fff',
		backgroundColor: '#4c4f53',
		whiteSpace: 'nowrap',
		'th&': {
			borderTop: 'none',
			position: 'sticky',
			top: '38px',
			zIndex: 2,
		},
		'&:nth-child(1)': {
			borderLeft: 'none',
		},
		'&:nth-child(2)': {
			left: 0,
		},
	},
	iconCell: {
		width: 32,
		minWidth: 32,
		maxWidth: 32,
	},
	closeButton: {
		padding: 2,
	},
	checkCell: {
		verticalAlign: 'middle',
		transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
	},
	checkIcon: {
		width: 24,
		height: 24,
		margin: '0 auto',
		'& .MuiSvgIcon-root': {
			color: 'rgb(2, 136, 209)',
		}
	},
	dialogTitle: {
		fontWeight: "bold",
		paddingBottom: 15,
	},
	dialogContent: {
		'& li': {
			marginTop: 2,
			marginBottom: 2,
		},
	},
	dataList: {
		display: 'flex',
		flexWrap: 'nowrap',
		'& dd:not(:first-child)': {
			marginLeft: 5,
		},
	},
	dataLabel: {
		display: 'flex',
		alignItems: 'center',
		width: 200,
		height: 38,
	},
	alertLabel: {
		width: 70,
	},
	dataSubLabel: {
		display: 'flex',
		alignItems: 'center',
		width: 110,
		height: 38,
	},
	textField: {
		width: 110,
	},
	sbdImeiSelect: {
		minWidth: 182,
	},
	intervalSecField: {
		display: 'flex',
		alignItems: 'center',
		height: 38,
	},
	iconSelect: {
		"& .MuiInputBase-input": {
			height: 24,
			paddingTop: 4,
			paddingBottom: 4,
		},
	},
	icon: {
		height: 20,
		width: 20,
	},
	iconBox: {
		height: 20,
		width: 20,
		margin: "0 auto",
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
	},
	circle: {
		background: "#0000FF",
		border: "1px solid #0000FF",
		borderRadius: "50%",
		height: 7,
		width: 7,
		margin: "0 auto"
	},
	aircraftIcon: {
		fill: "#0000ff",
	},
	linkIcon: {
		fill: "#757575",
	},
	alertBoxOn: {
		// color: "#000000",
	},
	alertBoxOff: {
		color: "#c0c0c0",
	},
	leftText: {
		textAlign: "left",
		float: "left",
	},
	rightText: {
		textAlign: "right",
		float: "right",
	},
	nearMissAlertText: {
		width: 110,
		display: 'flex',
		justifyContent: 'space-between',
	},
	plannedRouteSelect: {
		"& .MuiSelect-select.MuiSelect-select": {
			padding: "4px 24px 4px 0",
			height: 24,
		},
	},
	plannedRoutePlanName: {
		maxWidth: 500,
		minWidth: 200
	},
	newline: {
		whiteSpace: "break-spaces",
	},
});

const coPilotColumns = [
	[
		{ id: 'aircraft_code', label: 'Aircraft Code', style: {minWidth: 80}, rowSpan: 2, sortOder: 1},
		{ id: 'aircraft_name', label: 'Nickname', style: {minWidth: 80}, rowSpan: 2, sortOder: 2},
		{ id: 'sbd_imei', label: 'SBD IMEI', style: {minWidth: 120}, rowSpan: 2, sortOder: 3},
		{ id: 'data_source', label: 'External Source', style: {minWidth: 25}, rowSpan: 2},
		{ id: 'aircraft_icon_no', label: 'Icon', style: {minWidth: 40, width: 40, whiteSpace: 'break-spaces', padding: '0 10px'}, headerAlign: 'center', align: 'center', rowSpan: 2, sortOder: 4},
		{ id: 'alert', label: 'Alert', colSpan: 3},
		{ id: 'interval', label: 'Iridium Transmission Interval', style: {minWidth: 58, width: 58, whiteSpace: 'break-spaces'}, rowSpan: 2, sortOder: 8, align: 'right', formatter: (value) => (value ? `${value} sec` : "")},
		{ id: 'planned_route', label: 'Planned route', colSpan: 2},
	],
	[
		{ id: 'unupdated_alert_setting_flag', label: 'Not Updated', style: {minWidth: 80, width: 80}, sortOder: 5},
		{ id: 'approach_alert_setting_flag', label: 'Near Miss (horizontal/vertical)', style: {minWidth: 150, width: 150, whiteSpace: 'break-spaces'}, sortOder: 6},
		{ id: 'route_deviation_alert_setting_flag', label: 'Deviation', style: {minWidth: 80, width: 80}, sortOder: 7},
		{ id: 'is_links_plan', label: 'Type', style: {minWidth: 40, width: 40, whiteSpace: 'break-spaces', padding: '0 10px'}, headerAlign: 'center', align: 'center', sortOder: 9},
		{ id: 'flightplan_name', label: 'Flight Plan Name', style: {minWidth: 120}, sortOder: 10},
	]
];

const formInputHash = {
	'sbd_imei': {
		key: 'sbd_imei',
		rules: {},
		default: ""
	},
	'aircraft_icon_no': {
		key: 'aircraft_icon_no',
		rules: {},
		default: 0
	},
	'unupdated_alert_setting_flag': {
		key: 'unupdated_alert_setting_flag',
		type: 'boolean',
		rules: {},
		default: false
	},
	'unupdated_alert_threshold_min': {
		key: 'unupdated_alert_threshold_min',
		type: 'number',
		flagKey: 'unupdated_alert_setting_flag',
		rules: {
			required: false,
			pattern: /^[0-9]+$/,
			min: 2,
			max: 15
		},
		default: "5"
	},
	'approach_alert_setting_flag': {
		key: 'approach_alert_setting_flag',
		type: 'boolean',
		rules: {},
		default: false
	},
	'approach_alert_h_threshold_nm': {
		key: 'approach_alert_h_threshold_nm',
		type: 'number',
		flagKey: 'approach_alert_setting_flag',
		rules: {
			required: true,
			pattern: /^[0-9]+$/,
			min: 2,
			max: 50
		},
		default: "5"
	},
	'approach_alert_v_threshold_ft': {
		key: 'approach_alert_v_threshold_ft',
		type: 'number',
		flagKey: 'approach_alert_setting_flag',
		rules: {
			required: true,
			pattern: /^[0-9]+$/,
			min: 1000,
			max: 30000
		},
		default: "2000"
	},
	'route_deviation_alert_setting_flag': {
		key: 'route_deviation_alert_setting_flag',
		type: 'boolean',
		rules: {},
		default: false
	},
	'route_deviation_alert_threshold_nm': {
		key: 'route_deviation_alert_threshold_nm',
		type: 'number',
		flagKey: 'route_deviation_alert_setting_flag',
		rules: {
			required: true,
			pattern: /^[0-9]+$/,
			min: 1,
			max: 20
		},
		default: "5"
	},
	// 'interval': {
	// 	key: 'interval',
	// 	type: 'number',
	// 	rules: {},
	// 	default: ""
	// },
	'is_links_plan': {
		key: 'is_links_plan',
		rules: {},
		default: null
	},
	'flightplan_id': {
		key: 'flightplan_id',
		rules: {},
		default: ''
	}
};

const ExternalSourceListTableRow = memo(forwardRef((props, ref) => {
	const { aircraftCode, linkableSourceList, linkedDataSourceId } = props;

	const classes = useStyles();

	return (
		linkableSourceList.map((column, i) => (
			<TableCell
				key={`cell-${aircraftCode}-${column.data_source_id}`}
				align="center"
				padding="checkbox"
				style={{ minWidth: 0 }}
				className={clsx(classes.tableCell, classes.checkCell)}
			>
				{linkedDataSourceId?.includes(column.data_source_id) &&
					<Box className={clsx(classes.checkIcon)}>
						<CheckIcon color="secondary" />
					</Box>
				}
			</TableCell>
		))
	);
}));

const CoPilotListTable = memo(forwardRef(({handleEdit, setWaiting}, ref) => {
	const {
		coPilotSettingList,
		updateCoPilotLinkage,
		refreshCoPilotLinkageList
	} = useCoPilotLinkageList();
	const {
		linkableSourceList
	} = useLinkableSourceList(true);
	const { showError, showWarning } = useAlert();

	const classes = useStyles();
	const {t} = useTranslation();

	useEffect(() => {
		return () => {
			refreshCoPilotLinkageList();
		}
	}, [refreshCoPilotLinkageList]);

	useImperativeHandle(ref, () => ({
		update: (updateData) => {
			setWaiting(true);
			updateCoPilotLinkage(updateData)
				.catch(e => {
					let isLockError = false;
					const errorNames = [];
					const messages = [];
					[
						{key: 'coPilot', name: t('CoPilot setting')},
						{key: 'flightPlan', name: t('Planned route')},
					].forEach(target => {
						const _e = e[target.key];
						if (_e) {
							if (_e.progress) {
								messages.push(t('update_successful_caution', {name: target.name}));
							} else {
								errorNames.push(target.name);
								if (_e.reason.response?.status === 428) {
									isLockError = true;
								}
							}
						}
					});

					let caution = '';
					if (messages.length) {
						caution = [
							"\n",
							t('※※ Caution ※※'),
							...messages
						  ].join('\n');
					}
					if (isLockError) {
						showWarning(t('validate_optimistic_lock', {caution}));
						refreshCoPilotLinkageList();
					} else {
						showError(t('update_failed_with_name', {name: errorNames.join(', '), caution}));
						if (messages.length) {
							refreshCoPilotLinkageList();
						}
					}
				})
				.finally(() => {
					setWaiting(false);
				});
		}
	}));

	const columns = coPilotColumns
		.flat()
		.filter(c=> c.colSpan === undefined || c.colSpan === 1)
		.sort((a,b)=>{
			if(a.sortOder < b.sortOder) {
				return -1;
			} else if (a.sortOder > b.sortOder) {
				return 1;
			} else {
				return 0;
			}
		});

	return (
		<TableContainer className={classes.container}>
			<Table aria-label="sticky table" size="small" className={classes.stickyTable}>
				<TableHead>
					{coPilotColumns.map((columns, i, array) => (
						<TableRow key={i} className={classes.tableRow}>
							{i === 0 && <TableCell
								key='edit'
								className={clsx(classes.headerCell, classes.tableCell, classes.iconCell)}
								padding="none"
								rowSpan={array.length}
							>
							</TableCell>}
							{columns.map((column, j) => {
								let cellStyle = { minWidth: 0 };
								if (column.style) {
									cellStyle = { ...cellStyle, ...column.style };
								}
								if (column.id === 'data_source') {
									return (
										linkableSourceList.map((column, i) => (
											<TableCell
												key={column.data_source_id}
												style={cellStyle}
												className={clsx(classes.headerCell, classes.tableCell)}
												rowSpan={2}
											>
												{t(column.data_source_name)}
											</TableCell>
										))
									);
								} else {
									return (
										<TableCell
											key={column.id}
											align={column.headerAlign}
											style={cellStyle}
											className={clsx(classes.tableCell, i === 0 ? classes.headerCell : classes.headerSubCell)}
											padding={column.padding ? column.padding : "normal"}
											rowSpan={column.rowSpan ? column.rowSpan : 1}
											colSpan={column.colSpan ? column.colSpan : 1}
									>
										{t(column.label)}
									</TableCell>
									);
								}
							})}
						</TableRow>
					))}
				</TableHead>
				<TableBody>
					{coPilotSettingList.map((row, index) => {
						return (
							<TableRow hover role="checkbox" tabIndex={-1} key={`${index}_${row.aircraft_code}`}>
								<TableCell key='editBtn' className={clsx(classes.tableCell, classes.iconCell)} padding="none" align="center">
									<RoleControl subject={SUBJ_COPI_AIRCRAFT_LINKAGE} verb={VERB_UPDATE} >
										<IconButton aria-label="edit" size="small" className={classes.smallBtn} onClick={() => handleEdit(row)}>
											<Tooltip title="edit" arrow >
												<PencilIcon fontSize="small" />
											</Tooltip>
										</IconButton>
									</RoleControl>
								</TableCell>
								{columns.map((column, i) => {
									let value = row[column.id];
									if (column.formatter) {
										value = column.formatter(value);
									}

									if (column.id === 'flightplan_name') {
										if (row['start_time'] !== null) {
											const now = new Date().getTime();
											const startTime = new Date(row['start_time']).getTime();
											if (startTime > now) {
												value = `* ${value}`;
											}
										}
									}

									let cellStyle = { minWidth: 0 };
									if (column.style) {
										cellStyle = { ...cellStyle, ...column.style };
									}

									if (column.id === 'data_source') {
										return (
											<ExternalSourceListTableRow
												key={column.id}
												aircraftCode={row.aircraft_code}
												linkableSourceList={linkableSourceList}
												linkedDataSourceId={row.linked_data_source_id}
											/>
										);
									} else {
										return (
											<TableCell
												key={column.id}
												align={column.align}
												style={cellStyle}
												className={clsx(classes.tableCell)}
												padding={column.padding ? column.padding : "normal"}
											>
												{
													![
														'sbd_imei',
														'aircraft_icon_no',
														'unupdated_alert_setting_flag',
														'approach_alert_setting_flag',
														'route_deviation_alert_setting_flag',
														'is_links_plan',
													].includes(column.id) && value
												}
												{column.id === 'sbd_imei' && (value || t('Not associated'))}
												{column.id === 'aircraft_icon_no' && 
													<Box className={classes.iconBox}>
														{![6, 7, 8].includes(value) && <div className={classes.circle}/>}
														{value === 6 && <ImageHeli className={clsx(classes.icon, classes.aircraftIcon)}/>}
														{value === 7 && <ImageCessna className={clsx(classes.icon, classes.aircraftIcon)}/>}
														{value === 8 && <ImageNavi className={clsx(classes.icon, classes.aircraftIcon)}/>}
													</Box>
												}
												{column.id === 'unupdated_alert_setting_flag' &&
													<Box className={value ? classes.alertBoxOn : classes.alertBoxOff}>
														<span className={classes.leftText}>{value ? 'ON' : 'OFF'}</span>
														{value && <span className={classes.rightText}>{`${row['unupdated_alert_threshold_min']} min`}</span>}
													</Box>
												}
												{column.id === 'approach_alert_setting_flag' &&
													<Box className={value ? classes.alertBoxOn : classes.alertBoxOff}>
														<span className={classes.leftText}>{value ? 'ON' : 'OFF'}</span>
														{value && <span className={clsx(classes.rightText, classes.nearMissAlertText)}>
															<span>{`${row['approach_alert_h_threshold_nm']} NM`}</span>
															<span>/</span>
															<span>{`${row['approach_alert_v_threshold_ft']} ft`}</span>
														</span>}
													</Box>
												}
												{column.id === 'route_deviation_alert_setting_flag' &&
													<Box className={value ? classes.alertBoxOn : classes.alertBoxOff}>
														<span className={classes.leftText}>{value ? 'ON' : 'OFF'}</span>
														{value && <span className={classes.rightText}>{`${row['route_deviation_alert_threshold_nm']} NM`}</span>}
													</Box>
												}
												{column.id === 'is_links_plan' && 
													<Box className={classes.iconBox}>
														{value === false && <ImageLinked className={clsx(classes.icon, classes.linkIcon)}/>}
														{value === true && <img src={imageLinks} alt="created by FOSTER-Links" className={classes.icon} />}
													</Box>
												}
											</TableCell>
										);
									}
								})}
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</TableContainer>
	);
}));

function CoPilotAircraftSettingPopup({formData, handleSave, handleClose}) {
	const user = useRecoilValue(userState);

	const freeCoPilotList = useRecoilValue(freeCoPilotListState(user.customer));
	const linkableFlightPlan = useRecoilValue(linkableFlightPlanState(formData.aircraft_code));
	const linkableFlightPlanRefresher = useRecoilRefresher_UNSTABLE(linkableFlightPlanState(formData.aircraft_code));

	const [updateData, setUpdateData] = useState(null);
	const [openWarning, setOpenWarning] = useState(false);
	const handleWarningCancel = () => {
		setOpenWarning(false);
	};
	const handleWarningOk = () => {
		setOpenWarning(false);
		handleSave(updateData);
	};

	const handleKeyUp = e => {
		if (e.keyCode === 13) {
			handleWarningOk();
		}
	};

	useEffect(() => {
		//アンマウント時に紐付け可能なプラン一覧stateをクリアしておく(開くたびに取得する)
		return () => {
			linkableFlightPlanRefresher();
		}
	}, [linkableFlightPlanRefresher]);

	const plannedRoute = useMemo(() => {
		const _plannedRoute = linkableFlightPlan.reduce((a, v) => {
			if (v.is_links_plan) {
				if (!a.links) {
					a.links = [];
				} 
				a.links.push(v);
			} else {
				if (!a.external) {
					a.external = [];
				} 
				a.external.push(v);
			}
			return a;
		}, {});
		return _plannedRoute;
	}, [linkableFlightPlan]);

	const freeCoPilotHash = useMemo(() => {
		const _freeCoPilotHash = {};
		freeCoPilotList.forEach(freeCoPilot => {
			_freeCoPilotHash[freeCoPilot.sbd_imei] = freeCoPilot;
		});
		return _freeCoPilotHash;
	}, [freeCoPilotList]);

	const inputRefs = Object.keys(formInputHash).reduce((a, v) => (a[v] = createRef()) && a, {});
	const { control, getValues, setValue, trigger, formState: { errors, isDirty, isValid } } = useForm({
		mode: 'onChange',
		defaultValues: formData
	});

	const classes = useStyles();
	const {t} = useTranslation();

	const makeTextRules = useCallback((key) => {
		const item = formInputHash[key];
		return {
			validate: {
				message: (v) => {
					const values = getValues();
					//フラグOFFの場合はチェックなしで正常扱い
					if (!values[item.flagKey]) {
						return null;
					}
					//必須チェック
					if (item.rules.required && (v === undefined || v === null || v === "")) {
						return t('validate_required');
					}
					//パターンチェック
					if (item.rules.pattern && !item.rules.pattern.test(v)) {
						return t('validate_pattern');
					}
					//数値範囲チェック
					if (item.type === 'number' && 'min' in item.rules && 'max' in item.rules) {
						const num = Number(v);
						const min = item.rules.min;
						const max = item.rules.max;
						if (max < num || num < min) {
							return t('validate_number_out_of_range', { min, max });
						}
					}
					return null;
				}
			}
		};
	}, [getValues, t]);

	const onClickSave = useCallback(() => {
		//入力された値で更新データを作成
		const data = Object.keys(inputRefs).reduce((a, v) => {
			const item = formInputHash[v];
			if (item.type === 'boolean') {
				a[v] = inputRefs[v].current.checked;
			} else if (item.type === 'number') {
				//数値項目の値はnumberに変換
				a[v] = inputRefs[v].current.value - 0;
			} else {
				a[v] = inputRefs[v].current.value;
			}

			//threshold系項目は大元のflagがfalseであれば変更前の値をセット
			if ('flagKey' in item) {
				if (!inputRefs[item.flagKey].current.checked) {
					a[v] = item.type === 'number' ? formData[v] - 0 : formData[v];
				}
			}

			//sbd_imei, flightplan_idが空文字の場合は紐づけ解除を行った時なのでnullをセット
			if (['sbd_imei', 'flightplan_id'].includes(v) && a[v] === "") {
				a[v] = null;
			}
			return a;
		}, {});

		//Iridium更新間隔はSBD IMEIが変わると値も変わる。更新APIでIridium更新間隔もUPDATEされてしまうためSBD IMEIに対応した値に変更しておく
		data.interval = getValues().interval;

		//キー情報を更新データに追加
		data.aircraft_code = formData['aircraft_code'];

		// copi_update_settingに以下の項目にnullを渡すとErrorになるため、未設定の場合default値を設定する
		if (data.approach_alert_h_threshold_nm === null) {
			data.approach_alert_h_threshold_nm = formInputHash.approach_alert_h_threshold_nm.default - 0;
		}
		if (data.approach_alert_v_threshold_ft === null) {
			data.approach_alert_v_threshold_ft = formInputHash.approach_alert_v_threshold_ft.default - 0;
		}
		if (data.route_deviation_alert_threshold_nm === null) {
			data.route_deviation_alert_threshold_nm = formInputHash.route_deviation_alert_threshold_nm.default - 0;
		}

		const _updateData = {...formData, ...data, ...{'api_exec_user': user.userId}};

		if (data.sbd_imei !== null && formData.sbd_imei !== data.sbd_imei && freeCoPilotHash[data.sbd_imei].customer_code_contractor !== user.customer) {
			setOpenWarning(true);
			setUpdateData(_updateData);
		} else {
			handleSave(_updateData);
		}

	}, [formData, inputRefs, user, getValues, handleSave, freeCoPilotHash, setOpenWarning, setUpdateData]);

	const handleChangeSbdImei = useCallback((selectedImei) => {
		let intervalSec;
		if (formData['sbd_imei'] === selectedImei) {
			intervalSec = formData['interval'];
		} else {
			const target = freeCoPilotList.find(freeCoPilot => freeCoPilot.sbd_imei === selectedImei);
			intervalSec = target.interval;
		}
		setValue('interval', intervalSec, {shouldDirty: true});
	}, [formData, freeCoPilotList, setValue]);

	const handleUnlinkCoPilot = useCallback(() => {
		setValue('sbd_imei', "", {shouldDirty: true});
		setValue('interval', null, {shouldDirty: true});
	}, [setValue]);

	const handleChangePlanType = useCallback((selectedIsLinksPlan) => {
		let flightPlanId;
		if (formData['is_links_plan'] === selectedIsLinksPlan) {
			flightPlanId = formData['flightplan_id'];
		} else {
			if (selectedIsLinksPlan === true && "links" in plannedRoute) {
				flightPlanId = plannedRoute.links[0].flightplan_id;
			} else if (selectedIsLinksPlan === false && "external" in plannedRoute) {
				flightPlanId = plannedRoute.external[0].flightplan_id;
			} else {
				flightPlanId = "";
			}
		}
		setValue('flightplan_id', flightPlanId, {shouldDirty: true});
	}, [formData, plannedRoute, setValue]);

	const handleUnlinkPlan = useCallback(() => {
		setValue('is_links_plan', null, {shouldDirty: true});
		setValue('flightplan_id', "", {shouldDirty: true});
	}, [setValue]);

	const sbdImeiSelectList = [...freeCoPilotList].map(freeCoPilot => freeCoPilot.sbd_imei);
	if (formData['sbd_imei'] && !freeCoPilotList.includes(formData['sbd_imei'])) {
		sbdImeiSelectList.unshift(formData['sbd_imei']);
	}

	return (
		<>
			<Box style={{ display: 'flex', justifyContent: 'flex-end', flexDirection: 'row-reverse' }}>
				<Box style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column' }}>
					<Box style={{ marginLeft: 'auto'}}>
						<IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
							<CloseIcon />
						</IconButton>
					</Box>
					<Box>
						<Button variant="outlined" size="small" onClick={onClickSave} disabled={!(isDirty && isValid)}>{t('save')}</Button>
					</Box>
				</Box>
				<Box style={{ display: 'flex', flexDirection: 'column', paddingBottom: '40px' }}>
					<Box className={classes.dialogTitle}>{`${formData['aircraft_code']} (${formData['aircraft_name']})`}</Box>
					<ul className={classes.dialogContent}>
						<li>
							<dl className={classes.dataList}>
								<dt className={classes.dataLabel}>{t('SBD IMEI')}</dt>
								<dd>
									<Controller
										key={'sbd_imei'}
										name={'sbd_imei'}
										control={control}
										render={({ field: { name, onChange, onBlur, value } }) => (
											<Select
												id={`${name}-select`}
												value={sbdImeiSelectList.includes(value) ? value : ""}
												displayEmpty
												inputRef={inputRefs[name]}
												onChange={(e) => {
													onChange(e);
													handleChangeSbdImei(e.target.value);
												}}
												onBlur={onBlur}
												className={classes.sbdImeiSelect}
											>
												{sbdImeiSelectList.map((sbdImei, i) => {
													const associated = formData['sbd_imei'] === sbdImei;
													return (
														<MenuItem key={`sbd_imei-${i}`} value={sbdImei}>
															{sbdImei}
															{associated && " ✓"}
														</MenuItem>
													);
												})}
											</Select>
										)}
									/>
								</dd>
								<dd>
									<Button variant="outlined" size="small" color="secondary" onClick={handleUnlinkCoPilot}>{t('Unlink')}</Button>
								</dd>
							</dl>
						</li>
						<li>
							<dl className={classes.dataList}>
								<dt className={classes.dataLabel}>{t('Icon')}</dt>
								<dd>
									<Controller
										key={'aircraft_icon_no'}
										name={'aircraft_icon_no'}
										control={control}
										render={({ field: { name, onChange, onBlur, value } }) => (
											<Select
												id={`${name}-select`}
												value={[6, 7, 8].includes(value) ? value : 0}
												displayEmpty
												inputRef={inputRefs[name]}
												onChange={onChange}
												onBlur={onBlur}
												className={classes.iconSelect}
											>
												<MenuItem value={[6, 7, 8].includes(value) ? 0 : value}>
													<div className={classes.iconBox}>
														<div className={classes.circle}/>
													</div>
												</MenuItem>
												<MenuItem value={6}>
													<ImageHeli className={clsx(classes.icon, classes.aircraftIcon)}/>
												</MenuItem>
												<MenuItem value={7}>
													<ImageCessna className={clsx(classes.icon, classes.aircraftIcon)}/>
												</MenuItem>
												<MenuItem value={8}>
													<ImageNavi className={clsx(classes.icon, classes.aircraftIcon)}/>
												</MenuItem>
											</Select>
										)}
									/>
								</dd>
							</dl>
						</li>
						<li>
							<dl className={classes.dataList}>
								<dt className={clsx(classes.dataLabel, classes.alertLabel)}>{t('Alert')}</dt>
								<dd>
									<ul>
										<li>
											<dl className={classes.dataList}>
												<dt className={classes.dataSubLabel}>{t('Not Updated')}</dt>
												<dd>
													<Controller
														key={'unupdated_alert_setting_flag'}
														name={'unupdated_alert_setting_flag'}
														control={control}
														render={({ field: { name, onChange, onBlur, value } }) => (
															<Switch
																checked={value}
																onChange={(e) => {
																	onChange(e);
																	trigger('unupdated_alert_threshold_min');
																}}
																onBlur={onBlur}
																color="primary"
																name={name}
																inputRef={inputRefs[name]}
																inputProps={{ 'aria-label': 'primary checkbox' }}
															/>
														)}
													/>
												</dd>
												<dd>
													<Controller
														key={'unupdated_alert_threshold_min'}
														control={control}
														rules={makeTextRules('unupdated_alert_threshold_min')}
														render={({ field: { name, onChange, onBlur, value } }) => (
															<TextField
																id={name}
																name={name}
																className={classes.textField}
																variant="outlined"
																size="small"
																InputLabelProps={{
																	shrink: true,
																}}
																error={!!errors[name]}
																inputRef={inputRefs[name]}
																helperText={t(errors[name]?.message)}
																onChange={onChange}
																onBlur={onBlur}
																value={value}
																disabled={!getValues().unupdated_alert_setting_flag}
																InputProps={{
																	endAdornment: <InputAdornment position="end">min</InputAdornment>
																}}
															/>
														)}
														name={'unupdated_alert_threshold_min'}
													/>
												</dd>
											</dl>
										</li>
										<li>
											<dl className={classes.dataList}>
												<dt className={classes.dataSubLabel}>{t('Near Miss')}</dt>
												<dd>
													<Controller
														key={'approach_alert_setting_flag'}
														name={'approach_alert_setting_flag'}
														control={control}
														render={({ field: { name, onChange, onBlur, value } }) => (
															<Switch
																checked={value}
																onChange={(e) => {
																	onChange(e);
																	trigger('approach_alert_h_threshold_nm');
																	trigger('approach_alert_v_threshold_ft');
																}}
																onBlur={onBlur}
																color="primary"
																name={name}
																inputRef={inputRefs[name]}
																inputProps={{ 'aria-label': 'primary checkbox' }}
															/>
														)}
													/>
												</dd>
												<dd>
													<ul>
														<li>
															<dl className={classes.dataList}>
																<dt className={classes.dataSubLabel}>{t('horizontal')}</dt>
																<dd>
																	<Controller
																		key={'approach_alert_h_threshold_nm'}
																		control={control}
																		rules={makeTextRules('approach_alert_h_threshold_nm')}
																		render={({ field: { name, onChange, onBlur, value } }) => (
																			<TextField
																				id={name}
																				name={name}
																				className={classes.textField}
																				variant="outlined"
																				size="small"
																				InputLabelProps={{
																					shrink: true,
																				}}
																				error={!!errors[name]}
																				inputRef={inputRefs[name]}
																				helperText={t(errors[name]?.message)}
																				onChange={onChange}
																				onBlur={onBlur}
																				value={value}
																				disabled={!getValues().approach_alert_setting_flag}
																				InputProps={{
																					endAdornment: <InputAdornment position="end">NM</InputAdornment>
																				}}
																			/>
																		)}
																		name={'approach_alert_h_threshold_nm'}
																	/>
																</dd>
															</dl>
														</li>
														<li>
															<dl className={classes.dataList}>
																<dt className={classes.dataSubLabel}>{t('vertical')}</dt>
																<dd>
																	<Controller
																		key={'approach_alert_v_threshold_ft'}
																		control={control}
																		rules={makeTextRules('approach_alert_v_threshold_ft')}
																		render={({ field: { name, onChange, onBlur, value } }) => (
																			<TextField
																				id={name}
																				name={name}
																				className={classes.textField}
																				variant="outlined"
																				size="small"
																				InputLabelProps={{
																					shrink: true,
																				}}
																				error={!!errors[name]}
																				inputRef={inputRefs[name]}
																				helperText={t(errors[name]?.message)}
																				onChange={onChange}
																				onBlur={onBlur}
																				value={value}
																				disabled={!getValues().approach_alert_setting_flag}
																				InputProps={{
																					endAdornment: <InputAdornment position="end">ft</InputAdornment>
																				}}
																			/>
																		)}
																		name={'approach_alert_v_threshold_ft'}
																	/>
																</dd>
															</dl>
														</li>
													</ul>
												</dd>
											</dl>
										</li>
										<li>
											<dl className={classes.dataList}>
												<dt className={classes.dataSubLabel}>{t('Deviation')}</dt>
												<dd>
													<Controller
														key={'route_deviation_alert_setting_flag'}
														name={'route_deviation_alert_setting_flag'}
														control={control}
														render={({ field: { name, onChange, onBlur, value } }) => (
															<Switch
																checked={value}
																onChange={(e) => {
																	onChange(e);
																	trigger('route_deviation_alert_threshold_nm');
																}}
																onBlur={onBlur}
																color="primary"
																name={name}
																inputRef={inputRefs[name]}
																inputProps={{ 'aria-label': 'primary checkbox' }}
															/>
														)}
													/>
												</dd>
												<dd>
													<Controller
														key={'route_deviation_alert_threshold_nm'}
														control={control}
														rules={makeTextRules('route_deviation_alert_threshold_nm')}
														render={({ field: { name, onChange, onBlur, value } }) => (
															<TextField
																id={name}
																name={name}
																className={classes.textField}
																variant="outlined"
																size="small"
																InputLabelProps={{
																	shrink: true,
																}}
																error={!!errors[name]}
																inputRef={inputRefs[name]}
																helperText={t(errors[name]?.message)}
																onChange={onChange}
																onBlur={onBlur}
																value={value}
																disabled={!getValues().route_deviation_alert_setting_flag}
																InputProps={{
																	endAdornment: <InputAdornment position="end">NM</InputAdornment>
																}}
															/>
														)}
														name={'route_deviation_alert_threshold_nm'}
													/>
												</dd>
											</dl>
										</li>
									</ul>
								</dd>
							</dl>
						</li>
						<li>
							<dl className={classes.dataList}>
								<dt className={classes.dataLabel}>{t('Iridium Transmission Interval')}</dt>
								<dd>
									<Controller
										key={'interval'}
										name={'interval'}
										control={control}
										render={({ field: { value } }) => (
											<div className={classes.intervalSecField}>{value ? `${value} sec` : '---'}</div>
										)}
									/>
								</dd>
							</dl>
						</li>
						<li>
							<dl className={classes.dataList}>
								<dt className={classes.dataLabel}>{t('Planned route')}</dt>
								<dd>
									<Controller
										key={'is_links_plan'}
										name={'is_links_plan'}
										control={control}
										render={({ field: { name, onChange, onBlur, value } }) => {
											const disabled = Object.keys(plannedRoute).length === 0;
											return (
												<Select
													id="is_links_plan-select"
													value={value !== null ? value : ''}
													displayEmpty
													inputRef={inputRefs[name]}
													onChange={(e) => {
														onChange(e);
														handleChangePlanType(e.target.value);
													}}
													onBlur={onBlur}
													className={classes.plannedRouteSelect}
													disabled={disabled}
												>
													{(value === false || "external" in plannedRoute) &&
														<MenuItem value={false}>
															<ImageLinked className={clsx(classes.icon, classes.linkIcon)}/>
														</MenuItem>
													}
													{(value === true || "links" in plannedRoute) && 
														<MenuItem value={true}>
															<img src={imageLinks} alt="Route" className={classes.icon} />
														</MenuItem>}
												</Select>
											);
										}}
									/>
								</dd>
								<dd>
									<Controller
										key={'flightplan_id'}
										name={'flightplan_id'}
										control={control}
										render={({ field: { name, onChange, onBlur, value } }) => {
											const values = getValues();
											const isLinksPlan = values.is_links_plan;
											let plans = [];
											if (isLinksPlan === true && "links" in plannedRoute) {
												plans = plannedRoute.links;
											} else if (isLinksPlan === false && "external" in plannedRoute) {
												plans = plannedRoute.external;
											}

											let _value = "";
											let title = ""
											if (value) {
												let target = plans.find(plan => plan.flightplan_id === value);
												if (!target) {
													target = plans.find(plan => plan.flight_no === values.flight_no);
												}
												if (target !== undefined) {
													_value = target.flightplan_id;
													title = target.flightplan_name;
												}
											}

											return (
												<Select
													id="flightplan_id-select"
													value={_value}
													displayEmpty
													inputRef={inputRefs[name]}
													onChange={onChange}
													onBlur={onBlur}
													className={classes.plannedRoutePlanName}
													disabled={plans.length === 0}
													title={title}
												>
													{
														plans.map(plan => {
															const id = plan.flightplan_id;
															const name = plan.flightplan_name;
															const associated = formData['flightplan_id'] === id;
															return (
																<MenuItem key={id} value={id}>
																	{name}
																	{associated && " ✓"}
																</MenuItem>
															);
														})
													}
												</Select>
											);
										}}
									/>
								</dd>
								<dd>
									<Button variant="outlined" size="small" color="secondary" onClick={handleUnlinkPlan} disabled={getValues().is_forced === false}>{t('Unlink')}</Button>
								</dd>
							</dl>
						</li>
					</ul>
				</Box>
			</Box>
			<Dialog open={openWarning} onClose={handleWarningCancel} onKeyUp={handleKeyUp}>
				<DialogContent>
					<DialogContentText className={classes.newline}>{t('COPILOT_AIRCRAFT_LINKAGE_CONTRACTOR_CONFIRM', {sbd_imei: updateData?.sbd_imei})}</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleWarningCancel} color="primary">Cancel</Button>
					<Button onClick={handleWarningOk} color="primary">Ok</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

function CoPilotAircraftLinkage() {
	const childRef = useRef({});
	const [formData, setFormData] = useState({});
	const [open, setOpen] = useState(false);
	const [waiting, setWaiting] = useState(false);

	const handleEdit = useCallback((row) => {
		const _formData = Object.assign({}, row);
		// console.log(JSON.stringify(_formData));
		Object.keys(formInputHash).forEach(key => {
			if (formInputHash[key]) {
				if ('default' in formInputHash[key] && (_formData[key] === null || _formData[key] === undefined)) {
					_formData[key] = formInputHash[key].default;
				}
				if (formInputHash[key].type === 'number' && typeof _formData[key] !== 'string') {
					//TextFieldで編集する数値項目をStringに変換
					_formData[key] = "" + _formData[key];
				}
			}
		});
		setFormData(_formData);
		setOpen(true);
	}, []);

	const handleSave = useCallback((updateData) => {
		childRef.current.update(updateData);
		setOpen(false);
	}, []);

	const handleClose = useCallback(() => {
		setOpen(false);
	}, []);

	return (
		<Box style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
			<Box style={{ padding: '10px', flexGrow: 1, overflow: 'hidden' }}>
				{waiting && <Loading backdrop={true} />}
				<Suspense fallback={<Loading />}>
					<CoPilotListTable ref={childRef} handleEdit={handleEdit} setWaiting={setWaiting}/>
				</Suspense>
			</Box>
			<Suspense fallback={<Loading/>}>
				<Dialog maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
					<DialogContent>
						<CoPilotAircraftSettingPopup formData={formData} handleSave={handleSave} handleClose={handleClose}/>
					</DialogContent>
				</Dialog>
			</Suspense>
		</Box>
	);
};

export default CoPilotAircraftLinkage;
